import { useTranslation } from "react-i18next";
import { distance } from "../../Types/TableTypes";
import DynamicTextArea from "../DynamicTextArea";
import { getDistanceFromFt, getDistanceFromMt, getDistanceFromSq } from "../../Utils/Converters";
import { useEffect, useState } from "react";

interface OtherStatsComponentProps{
    otherStats: {
        skills: string;
        damageVulnerabilities: string;
        damageResistances: string;
        damageImmunities: string;
        conditionImmunities: string;
        senses: {
            passivePerception: number;
            darkvision: {
                distance: distance;
                text: string;
            };
            blindsight: {
                distance: distance;
                text: string;
            };
            tremorsense: {
                distance: distance;
                text: string;
            };
            truesight: {
                distance: distance;
                text: string;
            };
        };
        languages: string;
        challenge: string;
    },
    updateStats: (otherStats: {
        skills: string;
        damageVulnerabilities: string;
        damageResistances: string;
        damageImmunities: string;
        conditionImmunities: string;
        senses: {
            passivePerception: number;
            darkvision: {
                distance: distance;
                text: string;
            };
            blindsight: {
                distance: distance;
                text: string;
            };
            tremorsense: {
                distance: distance;
                text: string;
            };
            truesight: {
                distance: distance;
                text: string;
            };
        };
        languages: string;
        challenge: string;
    }) => void,
    editMode: boolean,
}

const OtherStatsComponent = (props: OtherStatsComponentProps)=> {

    const { t } = useTranslation();
    // const [otherStats, setOtherStats] = useState(props.otherStats);
    const [skills, setSkills] = useState(props.otherStats.skills);
    const [damageVulnerabilities, setDamageVulnerabilities] = useState(props.otherStats.damageVulnerabilities);
    const [damageResistances, setDamageResistances] = useState(props.otherStats.damageResistances);
    const [damageImmunities, setDamageImmunities] = useState(props.otherStats.damageImmunities);
    const [conditionImmunities, setConditionImmunities] = useState(props.otherStats.conditionImmunities);
    const [senses, setSenses] = useState(props.otherStats.senses);
    const [languages, setLanguages] = useState(props.otherStats.languages);
    const [challenge, setChallenge] = useState(props.otherStats.challenge);
    
    useEffect(() =>{
        setSkills(props.otherStats.skills);
        setDamageVulnerabilities(props.otherStats.damageVulnerabilities);
        setDamageResistances(props.otherStats.damageResistances);
        setDamageImmunities(props.otherStats.damageImmunities);
        setConditionImmunities(props.otherStats.conditionImmunities);
        setSenses(props.otherStats.senses);
        setLanguages(props.otherStats.languages);
        setChallenge(props.otherStats.challenge);
    },[props.otherStats])
    // console.log("otherstatscomp");
    return(
        <div className="mt-2 mb-2 ms-4 me-4">
            {(props.editMode || (!props.editMode && skills)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-skills")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.skills = text;
                                setSkills(text);
                            }}      
                            placeholder=""
                            areaText={skills}/>
                    :
                    <span>{skills}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && damageVulnerabilities)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-damagevulnerabilities")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.damageVulnerabilities = text;
                                setDamageVulnerabilities(text);
                            }}      
                            placeholder=""
                            areaText={damageVulnerabilities}/>
                    :
                    <span>{damageVulnerabilities}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && damageResistances)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-damageResistances")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.damageResistances = text;
                                setDamageResistances(text);
                            }}      
                            placeholder=""
                            areaText={damageResistances}/>
                    :
                    <span>{damageResistances}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && damageImmunities)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-damageImmunities")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.damageImmunities = text;
                                setDamageImmunities(text);
                            }}      
                            placeholder=""
                            areaText={props.otherStats.damageImmunities}/>
                    :
                    <span>{damageImmunities}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && conditionImmunities)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-conditionImmunities")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.conditionImmunities = text;
                                setConditionImmunities(text);
                            }}      
                            placeholder=""
                            areaText={conditionImmunities}/>
                    :
                    <span>{conditionImmunities}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && senses)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-senses")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <div>
                            <div className="input-group mt-1 mb-1">
                                <span className="input-group-text col-2">{t("senses-darkvision")}</span>
                                <input 
                                    value={senses.darkvision.distance.mt}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.darkvision.distance = getDistanceFromMt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">m</span>
                                <input 
                                    value={senses.darkvision.distance.ft}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.darkvision.distance = getDistanceFromFt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">ft</span>
                                <input 
                                    value={senses.darkvision.distance.sq}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.darkvision.distance = getDistanceFromSq(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">{t("sq")}</span>
                                <input 
                                    value={senses.darkvision.text}
                                    type="text"
                                    placeholder="other"
                                    className="form-control text-center col-4"
                                    onChange={e => {
                                        props.otherStats.senses.darkvision.text = e.target.value;
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                            </div>

                            <div className="input-group mt-1 mb-1">
                                <span className="input-group-text col-2">{t("senses-blindsight")}</span>
                                <input 
                                    value={senses.blindsight.distance.mt}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.blindsight.distance = getDistanceFromMt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">m</span>
                                <input 
                                    value={senses.blindsight.distance.ft}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.blindsight.distance = getDistanceFromFt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">ft</span>
                                <input 
                                    value={senses.blindsight.distance.sq}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.blindsight.distance = getDistanceFromSq(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">{t("sq")}</span>
                                <input 
                                    value={senses.blindsight.text}
                                    type="text"
                                    placeholder="other"
                                    className="form-control text-center col-4"
                                    onChange={e => {
                                        props.otherStats.senses.blindsight.text = e.target.value;
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                            </div>

                            <div className="input-group mt-1 mb-1">
                                <span className="input-group-text col-2">{t("senses-truesight")}</span>
                                <input 
                                    value={senses.truesight.distance.mt}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.truesight.distance = getDistanceFromMt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">m</span>
                                <input 
                                    value={senses.truesight.distance.ft}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.truesight.distance = getDistanceFromFt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">ft</span>
                                <input 
                                    value={senses.truesight.distance.sq}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.truesight.distance = getDistanceFromSq(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">{t("sq")}</span>
                                <input 
                                    value={senses.truesight.text}
                                    type="text"
                                    placeholder="other"
                                    className="form-control text-center col-4"
                                    onChange={e => {
                                        props.otherStats.senses.truesight.text = e.target.value;
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                            </div>

                            <div className="input-group mt-1 mb-1">
                                <span className="input-group-text col-2">{t("senses-tremorsense")}</span>
                                <input 
                                    value={senses.tremorsense.distance.mt}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.tremorsense.distance = getDistanceFromMt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">m</span>
                                <input 
                                    value={senses.tremorsense.distance.ft}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.tremorsense.distance = getDistanceFromFt(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">ft</span>
                                <input 
                                    value={senses.tremorsense.distance.sq}
                                    type="number"
                                    className="form-control text-center col-1"
                                    onChange={e => {
                                        props.otherStats.senses.tremorsense.distance = getDistanceFromSq(parseFloat(e.target.value));
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                                <span className="input-group-text col-1">{t("sq")}</span>
                                <input 
                                    value={senses.tremorsense.text}
                                    type="text"
                                    placeholder="other"
                                    className="form-control text-center col-4"
                                    onChange={e => {
                                        props.otherStats.senses.tremorsense.text = e.target.value;
                                        setSenses({...props.otherStats.senses})
                                    }}
                                ></input>
                            </div>
                        </div>
                    :
                    <div>
                        {/* todo fix ? (check violet fungus) */}
                        {senses.darkvision.distance.ft > 0 && 
                            <span>
                                {t("senses-darkvision")+" "+senses.darkvision.distance.mt+"m ("+senses.darkvision.distance.sq+"sq, "+senses.darkvision.distance.ft+"ft) "+senses.darkvision.text}
                            </span>
                        }
                        {senses.blindsight.distance.ft > 0 && 
                            <span>
                                {t("senses-blindsight")+" "+senses.blindsight.distance.mt+"m ("+senses.blindsight.distance.sq+"sq, "+senses.blindsight.distance.ft+"ft) "+senses.blindsight.text}
                            </span>
                        }
                        {senses.truesight.distance.ft > 0 && 
                            <span>
                                {t("senses-truesight")+" "+senses.truesight.distance.mt+"m ("+senses.truesight.distance.sq+"sq, "+senses.truesight.distance.ft+"ft) "+senses.truesight.text}
                            </span>
                        }
                        {senses.tremorsense.distance.ft > 0 && 
                            <span>
                                {t("senses-tremorsense")+" "+senses.tremorsense.distance.mt+"m ("+senses.darkvision.distance.sq+"sq, "+senses.darkvision.distance.ft+"ft) "+senses.tremorsense.text}
                            </span>
                        }
                    </div>
                }
            </div>}
            {(props.editMode || (!props.editMode && languages)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-languages")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.languages = text;
                                setLanguages(text);
                            }}      
                            placeholder=""
                            areaText={languages}/>
                    :
                    <span>{languages}</span>
                }
            </div>}
            {(props.editMode || (!props.editMode && challenge)) && <div className={(props.editMode ? "flex-column " : " ") +"d-flex"}>
                <span><b>{t("stats-challenge")}&nbsp;</b></span>
                {
                    props.editMode ? 
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.otherStats.challenge = text;
                                setChallenge(text);
                            }}      
                            placeholder=""
                            areaText={challenge}/>
                    :
                    <span>{challenge}</span>
                }
            </div>}
        </div>
    )
}
export default OtherStatsComponent;